const style = {
    div: {
      width: '30%',
      border: '1px solid #A9A9A9',
      marginTop: '2%',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '10px',
      borderRadius: '25px',
    },
    h1: {
      textAlign: 'center',
      color: "#6290C8",
      fontSize: "25px",
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    inputs: {
      width: '100%',
      padding: '12px 20px',
      margin: '8px 0',
      border: "none",
      borderBottomColor: "#A9A9A9",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
    },
    secondInputs: {
      width: '100%',
      padding: '12px 20px',
      marginBottom: '8px',
      border: "none",
      borderBottomColor: "#A9A9A9",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
    },
    button: {
      width: '100%',
      padding: '10px',
      marginBottom: '10px',
    },
    p: {
      textAlign: 'center',
    },
    link: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: "auto",
    }
}

export default style